<div class="p-6 bg-component-inner border border-secondary-border rounded-xl shadow-sm flex flex-col gap-4">
  <header class="flex flex-col gap-2 border-b border-secondary-border pb-4">
    <h2 class="text-xl font-bold text-heading">
      <i class="fas fa-table text-primary"></i>
      {{ event.title }}
    </h2>
    @if(event.description && showEventDescription) {
    <p class="text-secondary-text text-sm leading-relaxed">
      {{ event.description }}
    </p>
    }
  </header>
  <div class="pt-2">
    @if (displayWithSpreadsheet) {
    <rapider-project-model-spreadsheet-viewer [projectModelName]="event.projectModelName"
                                              [recordIds]="event.recordIds"
                                              [payloadData]="event.payloadData"
                                              [operationType]="event.operationType">
    </rapider-project-model-spreadsheet-viewer>
    } @else {
    <rapider-project-model-data-viewer [projectModelName]="event.projectModelName"
                                       [recordIds]="event.recordIds"
                                       [payloadData]="event.payloadData"
                                       [operationType]="event.operationType">
    </rapider-project-model-data-viewer>
    }
  </div>
</div>